import ColorHash from "color-hash";

const ID_ALPHA_HEX = Math.round(0.25 * 255).toString(16);

export function id2BgColor(botId) {
  return new ColorHash({ lightness: 0.9, saturation: 1 }).hex(botId) + ID_ALPHA_HEX;
}

export function componentToHex(c) {
  const hex = c.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

export function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

/**
 * 0% - red
 * 100% - green
 * */
export function createRedToGreenColor(percent) {
  const r = percent < 50 ? 205 : Math.floor(255 - (percent * 2 - 100) * 205 / 100);
  const g = percent > 50 ? 205 : Math.floor(percent * 2 * 205 / 100);

  return rgbToHex(r, g, 50);
}



// WEBPACK FOOTER //
// ./src/utils/colorUtils.js